import {
    IAPIEmployeeReferenceStatistics,
    IEmployeeReferenceStatistics,
} from './IEmployeeReference'

class Transformer {
    static transform(references: IAPIEmployeeReferenceStatistics[]): IEmployeeReferenceStatistics[] {
        return references.map((reference: IAPIEmployeeReferenceStatistics) => {
            return {
                personUuid: reference.person_uuid,
                loyalty: {
                    chosenCount: reference.loyalty.chosen_count,
                    chosenMinutes: reference.loyalty.chosen_minutes,
                    randomCount: reference.loyalty.random_count,
                    randomMinutes: reference.loyalty.random_minutes,
                },
            }
        })
    }
}
export default Transformer
